import type { ReactNode } from 'react';

type AuthShellProps = {
  children: ReactNode;
  /** Show blurred dashboard preview behind the panel (default: false) */
  showBackdrop?: boolean;
};

export function AuthShell({ children, showBackdrop = false }: AuthShellProps) {
  return (
    <div className="auth-shell flex min-h-screen items-center justify-center px-4">
      {showBackdrop && (
        <>
          <div className="auth-shell__backdrop" aria-hidden="true" />
          <div className="auth-shell__overlay" aria-hidden="true" />
        </>
      )}
      <div className="auth-shell__panel">
        {children}
      </div>
    </div>
  );
}
